import { AccountSellerLinkResponse } from 'domain/profil/AccountSellerLinkResponse';

interface RestAccountSellerLinkResponse {
  link: string;
}

export const toAccountLinkResponse = (
  restAccountSellerLinkResponse: RestAccountSellerLinkResponse,
) => new AccountSellerLinkResponse(restAccountSellerLinkResponse.link);
